import BaseInputField from './BaseInputField';
import $ from 'cash-dom';
import UrlHelper from '../../../../components/UrlHelper';
import BaseField from './BaseField';

class RadioGroupField extends BaseInputField {
	constructor($input) {
		super($input);
		this._name = this._getName();

		if (!this._getSelectedOption().length) {
			this.setValue('');
		}

		this._$input.on('change', 'input[type="radio"]', this._handleRadioChange);
	}

	_getLabel() {
		return this._getSelectedOption().next('span').text().trim();
	}

	getValue() {
		return this._getSelectedOption().val() || '';
	}

	setValue(filterValue) {
		const $target = this._$input.find(`input[value="${filterValue}"]`);
		if ($target.length) {
			$target.prop('checked', true);
		}
	}

	setValueAndTriggerEvent(filterValue) {
		this.setValue(filterValue);
		this._triggerChangeEvent();
	}

	reset() {
		const $defaultOption = this._$input.find('input[value=""]');
		if ($defaultOption.length) {
			$defaultOption.prop('checked', true).trigger('change');
		}
	}

	_handleRadioChange = (e) => {
		const $radio = $(e.currentTarget);
		const redirectLink = $radio.data('link');
		const isDefaultOption = $radio.val() === '';

		this._isLinkTheSameAsCurrentUrl = redirectLink
			? UrlHelper.isLinkTheSameAsCurrentUrl(redirectLink)
			: false;

		$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
			filterName: this.name,
			currentFieldValue: this.getValue(),
			redirectLink: !isDefaultOption ? redirectLink : null,
		});
	}

	getVendors() {
		return this._getSelectedOption().data('vendors');
	}

	getVendorsWithOrder() {
		return this._getSelectedOption().data('vendors-with-order');
	}

	_getDeeplinks() {
		return this._getSelectedOption().data('deeplinks');
	}

	_getSelectedOption() {
		return this._$input.find('input[type="radio"]:checked');
	}

	_getName() {
		return this._$input.find('input[type="radio"]').first().attr('name');
	}

	_triggerChangeEvent() {
		const $selected = this._getSelectedOption();
		if ($selected.length) {
			$selected.trigger('change');
		}
	}

	getShowVisiblyHiddenVendor() {
		return !!this._getSelectedOption().data('show-visibly-hidden-vendor');
	}

	isWithVisiblyHiddenSplit() {
		return !!this._$input.data('is-with-visibly-hidden-split');
	}
}

export default RadioGroupField;